import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";


export default function BackButton() {
  const navigate = useNavigate();

  return (
    <button
    onClick={() => {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate("/"); // or any default
        }
      }}
      className="flex"
    >
      <ChevronLeftIcon className="h-6 w-6"/>
      Back
    </button>
  );
}

  